const {Offcanvas} = require("bootstrap");

$(() => {
    $('#openMobileMenu').click(() => {
        const offcanvas = new Offcanvas($('#mobileMenuModal'))
        offcanvas.show();
    });
});